import React from "react";
import "./page-loader.css";

/**
 * Full-viewport boot / route loader.
 * Surface background + visible ink spinner — never a grey canvas slab with a
 * near-invisible white Auth0 GIF.
 */
export const PageLoader = () => (
  <div className="page-loader" data-testid="page-loader" role="status" aria-live="polite" aria-busy="true">
    <div className="page-loader__spinner" aria-hidden="true" />
    <span className="page-loader__label">Loading</span>
  </div>
);
